// extracted by mini-css-extract-plugin
module.exports = {"rmsc":"styles-module__rmsc___1aGPV","rmsc-sm":"styles-module__rmsc-sm___2pYM3","rmsc-md":"styles-module__rmsc-md___2n2HF"};